import { Card, CardContent, CardHeader, Link, useRouter } from '@forgeglobal/design-framework'
import { Routes } from 'util/Routes'
import { useIssuerLinksQuery } from 'graphql/bindings/AdminBindings'
import React from 'react'

const IssuerLinks: React.FC = () => {
  const { match } = useRouter<{ id: string }>()
  const { data } = useIssuerLinksQuery({ variables: { issuerId: match.params.id } })
  const company = data?.account?.issuer_account?.company

  return company ? (
    <Card>
      <CardHeader title="Links" />
      <CardContent>
        <b>
          <Link href={Routes.adminCompanyPage(company.id)} target="_blank">
            ADMIN
          </Link>
          <br />
          <Link href={Routes.platformCompanyPage(company.token)} target="_blank">
            PLATFORM
          </Link>
          <br />
          <Link href={Routes.crunchbaseCompanyPage(company.crunchbase_handle)} target="_blank">
            CRUNCHBASE
          </Link>
        </b>
      </CardContent>
    </Card>
  ) : null
}

export { IssuerLinks }
